import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FETCH_SAP_STATION_DETAILS, UPDATE_SAP_STATION_DETAILS } from 'actions/sap';
import ReactPagination from 'components/general/ReactPagination';
import { Modal, Button } from 'react-bootstrap';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { toast } from 'react-toastify';

const UpdateStationDetails = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchText, setSearchText] = useState('');
    const [isExternalStation, setIsExternalStation] = useState(false);
    const isLoader = useSelector((state) => state.sapData.isLoading);
    const allSapStationData = useSelector((state) => state.sapData.sapStationDetails);
    const page = useSelector((state) => state.sapData.page);
    const totalPages = useSelector((state) => state.sapData.totalPages);
    const limit = useSelector((state) => state.sapData.limit);
    const totalData = useSelector((state) => state.sapData.total);
    const [showModal, setShowModal] = useState(false);
    const [editingStation, setEditingStation] = useState(null);
    const [modalData, setModalData] = useState({
        businessPlace: '',
        glaCreditAccount: '',
        wbsElement: '',
    });


    const fetchSapStationDetails = useCallback(
        (data = {}) => {
            const payload = {
                ...data,
                limit,
                page: data.page || 1,
                ...(searchText && { search: searchText }),
                ...(isExternalStation && { is_external_station: true }),
            };

            dispatch({
                type: FETCH_SAP_STATION_DETAILS.REQUEST,
                payload,
            });
        },
        [searchText, isExternalStation, limit, page, dispatch]
    );



    useEffect(() => {
        fetchSapStationDetails();
    }, [searchText, isExternalStation]);

    const handleSearch = () => {
        fetchSapStationDetails({});
    };

    const handlePageClick = useCallback(
        (page) => {
            if (searchText) {
                const data = {
                    search: searchText,
                    page: page.selected + 1,
                };
                fetchSapStationDetails(data);
            } else {
                const data = {
                    page: page.selected + 1,
                };
                fetchSapStationDetails(data);
            }
        },
        [searchText, isExternalStation]
    );


    const handleOpenModal = (station) => {
        setEditingStation(station);
        setModalData({
            businessPlace: station.businessPlace || '',
            glaCreditAccount: station.glaCreditAccount || '',
            wbsElement: station.wbsElement || '',
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingStation(null);
        setModalData({
            businessPlace: '',
            glaCreditAccount: '',
            wbsElement: '',
        });
    };

    const handleModalChange = (field, value) => {
        setModalData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleUpdateStation = () => {
        if (!editingStation) return;

        const stationIdKey = isExternalStation ? 'ocpi_station_id' : '_id';

        dispatch({
            type: UPDATE_SAP_STATION_DETAILS.REQUEST,
            payload: {
                [stationIdKey]: isExternalStation ? editingStation.station_id : editingStation._id,
                ...(isExternalStation && { is_external_station: true }),
                ...modalData,
            },
            cb: (res) => {
                if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
                    handleCloseModal();
                    fetchSapStationDetails();
                    toast.success("Station Updated Successfully");
                }
            },
        });
    };


    return (
        <>
            <LayoutContainer>
                <AdminHeader title={t('sap.updateStationDetails')} />
                <div className="page-content-wrapper scrollable">
                    <div className="countryList-page">
                        <Card>
                            <div className="countryList-page-wrapper">
                                <Row className="countryList-search-box">
                                    <Col xl={10} lg={10} md={8} className="countryList-search-inputBox">
                                        <SearchBox
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearch();
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col xl={2} lg={2} md={4} className="countryList-search-inputBox">
                                        <div
                                            style={{
                                                marginBottom: '1.5rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <label className="me-2">{t('External Stations')}</label>

                                            <label
                                                style={{
                                                    position: 'relative',
                                                    display: 'inline-block',
                                                    width: '40px',
                                                    height: '20px',
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={isExternalStation}
                                                    onChange={() => setIsExternalStation(!isExternalStation)}
                                                    aria-label={t('External Stations')} // <-- Add this line
                                                    style={{
                                                        opacity: 0,
                                                        width: 0,
                                                        height: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: 'absolute',
                                                        zIndex: 2,
                                                        cursor: 'pointer',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                    }}
                                                />
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        cursor: 'pointer',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: isExternalStation ? '#4caf50' : '#ccc',
                                                        borderRadius: '20px',
                                                        transition: '0.4s',
                                                    }}
                                                ></span>
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        content: '""',
                                                        height: '16px',
                                                        width: '16px',
                                                        left: isExternalStation ? '22px' : '2px',
                                                        bottom: '2px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%',
                                                        transition: '0.4s',
                                                    }}
                                                ></span>
                                            </label>
                                        </div>
                                    </Col>

                                </Row>
                                <div className="countryList-table">
                                    <div className="table-responsive">
                                        <table className="record-list-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <span>{t('sap.srNo')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.stationId')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.name')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.chargerId')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.businessPlace')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.glaCreditAccount')}</span>
                                                    </th>
                                                    <th>
                                                        <span>{t('sap.wbsElement')}</span>
                                                    </th>
                                                    <th className="action-col">
                                                        <span>{t('sap.action')}</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoader ? (
                                                    <tr>
                                                        <td colSpan={10} className="border-0">
                                                            <div className="loader--block">
                                                                <Spinner as="span" animation="border" size="sm" role="status" />
                                                                <span className="ps-2">{t('placeHolder.loading')}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : _.isEmpty(allSapStationData) ? (
                                                    <tr>
                                                        <td colSpan={6} className="border-0">
                                                            <div className="empty-data-block">{t('No data Found')}</div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    !(isLoader || _.isUndefined(isLoader)) &&
                                                    _.map(allSapStationData, (item, key) => {
                                                        return (
                                                            <tr key={`country-${key}`}>
                                                                <td>{key + 1}</td>
                                                                <td>{_.get(item, 'station_id', '')}</td>
                                                                <td>{_.get(item, 'name', '')}</td>
                                                                <td>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${item.station_id}`} >
                                                                                {item.charger_id.join(', ')}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span style={{ cursor: 'pointer' }}>
                                                                            {item.charger_id.slice(0, 1).join(', ')}
                                                                            {item.charger_id.length > 1 && '...'}
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </td>
                                                                <td>{_.get(item, 'businessPlace', '')}</td>
                                                                <td>{_.get(item, 'glaCreditAccount', '')}</td>
                                                                <td>{_.get(item, 'wbsElement', '')}</td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={() => handleOpenModal(item)}
                                                                    >
                                                                        {t('Update')}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })

                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {!_.isEmpty(allSapStationData) && (
                                <ReactPagination
                                    currentPage={page}
                                    limit={limit}
                                    total={totalData}
                                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                                    totalPages={totalPages}
                                    marginPagesDisplayed={1}
                                />
                            )}
                        </Card>
                    </div>
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Header
                            closeButton
                            style={{ backgroundColor: '#1b2a38', color: '#fff', borderBottom: '1px solid #444' }}
                        >
                            <Modal.Title style={{ color: 'white' }}>{t('Update Station Details')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: '#1b2a38' }}>
                            <div className="form-group mb-3">
                                <label style={{ color: 'white' }}>{t('sap.businessPlace')}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={modalData.businessPlace}
                                    onChange={(e) => handleModalChange('businessPlace', e.target.value)}
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label style={{ color: 'white' }}>{t('sap.glaCreditAccount')}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={modalData.glaCreditAccount}
                                    onChange={(e) => handleModalChange('glaCreditAccount', e.target.value)}
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label style={{ color: 'white' }}>{t('sap.wbsElement')}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={modalData.wbsElement}
                                    onChange={(e) => handleModalChange('wbsElement', e.target.value)}
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer style={{ backgroundColor: '#1b2a38', borderTop: '1px solid #444' }}>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                {t('Cancel')}
                            </Button>
                            <Button variant="primary" onClick={handleUpdateStation}>
                                {t('Update')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </LayoutContainer>
        </>
    );
};
export default UpdateStationDetails;
